import React, { useState } from 'react';
import Button from '../../../Button';
import { useRegister } from '../../../../hooks/register';
import {
 Container, Title, Subtitle, CompanyRow, Checkbox, Label, Icon
} from './styles';
import { BackButton } from '../../styles';

const companies = [
  { id: '5bd36f0f1d9612f3ec291d95', name: 'americanas s.a', img: 'img/brands/icons/americanas.png' },
  { id: '5eecc2f73a56790da0f8313c', name: 'AME', img: 'img/brands/icons/ame.png' },
  { id: '5eecc1963a56790da0f830a3', name: 'LET’S', img: 'img/brands/icons/lets.png' },
];

const CompanySelection: React.FC = () => {
  const { handleStep, handleData, userData } = useRegister();
  const [companyId, setCompanyId] = useState(userData?.companyId || '');

  const handleSelect = (id: string) => {
    setCompanyId(id);
    handleData({ companyId: id });
  };

  return (
    <Container>
      <Title>Selecione sua empresa:</Title>
      <Subtitle>Por favor, selecione abaixo sua empresa:</Subtitle>

      {companies.map((company) => (
        <CompanyRow key={company.id} selected={companyId === company.id} onClick={() => handleSelect(company.id)}>
          <Checkbox selected={companyId === company.id} />
          <Label>{company.name}</Label>
          <Icon src={company.img} />
        </CompanyRow>
      ))}

      <Button disabled={!companyId} title="Continuar" classType="fat big" onClick={() => handleStep('fillName')} />

      <BackButton onClick={() => handleStep('privatePolicy')} />
    </Container>
  );
};

export default CompanySelection;
